import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { OneKlicksFileSDK } from '../../../../SDK/OneKlicksFileSDK';
import { oneKlicks } from '../../../../SDK/oneclick';
import { getuserdata, encryptId } from '../../../../services/apiService';
import { toast } from 'react-toastify';

const SeoSettings = ({ userId, doctorData, onActivityLog }) => {
    const [isEdit, setIsEdit] = useState(false);
    const [selectedPage, setSelectedPage] = useState(null);
    const [doctor, setDoctor] = useState({});
    const [localSeo, setLocalSeo] = useState({
        // Global SEO Settings
        id: '',
        title: '',
        site_title: '',
        site_description: '',
        site_keywords: '',
        site_author: '',
        site_robots: 'index, follow',
        site_canonical: '',

        // Open Graph
        og_title: '',
        og_description: '',
        og_image: '',
        og_type: 'website',
        og_site_name: '',
        og_locale: 'en_US',

        // Twitter Card
        twitter_card: 'summary_large_image',
        twitter_site: '',
        twitter_creator: '',
        twitter_title: '',
        twitter_description: '',
        twitter_image: '',

        // Analytics
        google_analytics: '',
        google_tag_manager: '',
        facebook_pixel: '',
        google_ads: '',

        // Schema.org
        schema_type: 'Organization',
        schema_name: '',
        schema_description: '',
        schema_url: '',
        schema_logo: '',
        schema_contact_point: '',
        schema_same_as: '',

        // Custom Meta
        custom_meta_tags: '',
        custom_head_code: '',
        custom_body_code: '',

        // Page SEO
        page_title: '',
        page_path: '',
        page_id: '',

        cronical_title: '',
        cronical_description: '',
        cronical_keywords: '',
        cronical_image: '',
        cronical_url: '',
        cronical_type: '',
        cronical_site_name: '',

        // Pages
        pages: {}
    });

    useEffect(() => {
        
        getDoctor();
    }, [userId, doctorData]);

    const getDoctor = async () => {
        if (userId) {
            setDoctor(doctorData || {});
            getSeoData(userId, doctorData?.display_name);
        } else {
            const doctor = await getuserdata('full');
            setDoctor(doctor);
            getSeoData();
        }
    };

    const formatUrlString = (name) => {
        console.log("getSeoData conditions :", name);
        if (!name) return '';
        let formattedName = name.replace(/^dr[-_\s]+/i, '');
        formattedName = formattedName.replace(/\|/g, '').replace(/&amp;/g, 'and');
        formattedName = formattedName.replace(/\//g, '-');
        formattedName = formattedName.replace(/[.\s]+/g, '-');
        formattedName = formattedName.toLowerCase();
        formattedName = formattedName.replace(/-+/g, '-');
        formattedName = formattedName.replace(/^-+|-+$/g, '');
        return formattedName;
    };

    const getSeoData = async (passedUserId, passedDisplayName) => {
        const tableSchema = '';
        const tableName = 'seo_data';
        const name = passedDisplayName || await getuserdata('display_name');
        const userid = passedUserId || await getuserdata('id');
        
        if (!userid) {
            console.warn("No userid found, skipping getSeoData");
            return;
        }

        const nameurl = formatUrlString(name);
        const pagePath = `/doctor/dr-${nameurl}/${encryptId(userid)}`;
        const conditions = {
            page_path: pagePath,
        };
        const orderBy = "id DESC";
        const search = "";
        const pagination = "";
        const margedata = "";
        
        console.log("getSeoData conditions :", conditions);
        try {
            const seoData = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("getSeoData seoData", seoData);
            if (seoData && seoData.success && seoData.data && seoData.data.length > 0) {
                setLocalSeo({   
                    ...localSeo,
                    ...seoData.data[0],
                    id: seoData.data[0].id,
                    page_path: pagePath,
                    page_id: seoData.data[0].page_id,
                    page_title: seoData.data[0].page_title,
                });
            } else {
                setLocalSeo({
                    ...localSeo,
                    id: '',
                    page_path: pagePath,
                    title: `${name} | MeddyList`,
                    description: `Find expert medical services from ${name} on MeddyList. View specialities, reviews, and book appointments online.`,
                    keywords: `${name}, doctor, medical specialist, MeddyList`,
                    og_title: `${name} - Professional Profile | MeddyList`,
                    og_description: `Connect with ${name} on MeddyList. Explore specialities and healthcare services.`,
                    twitter_title: `${name} | MeddyList`,
                    twitter_description: `Book your appointment with ${name} via MeddyList today.`,
                    cronical_url: window.location.origin + pagePath,
                });
            }
        } catch (error) {
            console.error("Error in getSeoData read:", error);
        }
    };

    const handleChange = async (field, value) => {
        console.log("handleChange", field, value);
        setLocalSeo({ ...localSeo, [field]: value });
    };

    const handleImageChange = async (e, field) => {
        console.log("handleImageChange", e, field);
        const file = e.target.files[0];
        console.log("handleImageChange file", file);
        const root = 'seo';
        const status = 'public';
        const upload = await OneKlicksFileSDK.uploadFile(root, status, file);
        console.log("handleImageChange upload seo settings file :", upload);
        const url = process.env.REACT_APP_API_BASE_LIVE_URL + upload.file.root + '/' + upload.file.fileName;
        console.log("handleImageChange upload seo settings file url :", url);
        if (upload.success) {
            if (field === 'file_og_image') {
                setLocalSeo({ ...localSeo, [field]: url, og_image: url });
            } else if (field === 'file_twitter_image') {
                setLocalSeo({ ...localSeo, [field]: url, twitter_image: url });
            } else if (field === 'file_cronical_image') {
                setLocalSeo({ ...localSeo, [field]: url, cronical_image: url });
            }
        }
    };

    const resetToDefault = () => {
        setLocalSeo({
            ...localSeo,
            id: '',
            title: '',
            description: '',
            keywords: '',
        });
    };

    const handleSavePageSeo = async () => {
        console.log("handleSavePageSeo", localSeo);
        const tableSchema = '';
        const tableName = 'seo_pages';
        const pagePath = `/doctor/dr-${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`;
        
        const data = {
            path: pagePath,
            title: localSeo.title,
            description: localSeo.description,
            type: 'page',
        };
        const conditions = {
            path: pagePath,
        };

        // Prepare the full SEO data object
        const pageSeo = {
            title: localSeo.title || '',
            description: localSeo.description || '',
            keywords: localSeo.keywords || '',
            site_title: localSeo.site_title || '',
            site_description: localSeo.site_description || '',
            site_keywords: localSeo.site_keywords || '',
            site_author: localSeo.site_author || '',
            site_robots: localSeo.site_robots || 'index, follow',
            site_canonical: localSeo.site_canonical || '',
            og_title: localSeo.og_title || '',
            og_description: localSeo.og_description || '',
            og_image: localSeo.og_image || '',
            og_type: localSeo.og_type || 'website',
            og_site_name: localSeo.og_site_name || '',
            og_locale: localSeo.og_locale || 'en_US',
            twitter_card: localSeo.twitter_card || 'summary_large_image',
            twitter_site: localSeo.twitter_site || '',
            twitter_creator: localSeo.twitter_creator || '',
            twitter_title: localSeo.twitter_title || '',
            twitter_description: localSeo.twitter_description || '',
            twitter_image: localSeo.twitter_image || '',
            google_analytics: localSeo.google_analytics || '',
            google_tag_manager: localSeo.google_tag_manager || '',
            facebook_pixel: localSeo.facebook_pixel || '',
            google_ads: localSeo.google_ads || '',
            schema_type: localSeo.schema_type || 'Organization',
            schema_name: localSeo.schema_name || '',
            schema_description: localSeo.schema_description || '',
            schema_url: localSeo.schema_url || '',
            schema_logo: localSeo.schema_logo || '',
            schema_contact_point: localSeo.schema_contact_point || '',
            schema_same_as: localSeo.schema_same_as || '',
            custom_meta_tags: localSeo.custom_meta_tags || '',
            custom_head_code: localSeo.custom_head_code || '',
            custom_body_code: localSeo.custom_body_code || '',
            cronical_title: localSeo.cronical_title || '',
            cronical_description: localSeo.cronical_description || '',
            cronical_keywords: localSeo.cronical_keywords || '',
            cronical_image: localSeo.cronical_image || '',
            cronical_url: localSeo.cronical_url || '',
            cronical_type: localSeo.cronical_type || '',
            cronical_site_name: localSeo.cronical_site_name || '',
            page_path: pagePath,
            page_title: localSeo.title || ''
        };

        try {
            if (localSeo.id === '') {
                const createseopage = await oneKlicks.create(tableSchema, tableName, data, conditions);
                if (createseopage.success) {
                    pageSeo.page_id = createseopage.insertedData.id;
                    const seoData = await oneKlicks.create('', 'seo_data', pageSeo, {});
                    if (seoData.success) {
                        toast.success("SEO Settings saved successfully");
                        getSeoData();
                        if (onActivityLog) {
                            onActivityLog("seo_update", "created search engine optimization (SEO) configurations");
                        }
                    }
                }
            } else {
                const updateConditions = { id: localSeo.id };
                const seoData = await oneKlicks.update('', 'seo_data', pageSeo, updateConditions);
                if (seoData.success) {
                    toast.success("SEO Settings updated successfully");
                    getSeoData();
                    if (onActivityLog) {
                        onActivityLog("seo_update", "updated search engine optimization (SEO) configurations");
                    }
                }
            }
        } catch (error) {
            console.error("Save SEO Error:", error);
            toast.error("Failed to save SEO settings");
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-securityhold tab-pane active fade show" id="dc-security">
                <div className="dc-securitysettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Seo Settings</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding">
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Page Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Page Title"
                                            value={localSeo.title || ''}
                                            onChange={(e) => handleChange('title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Meta Description</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Meta Description"
                                            value={localSeo.description || ''}
                                            onChange={(e) => handleChange('description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Keywords</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="keyword1, keyword2, keyword3"
                                            value={localSeo.keywords || ''}
                                            onChange={(e) => handleChange('keywords', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>OG Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Open Graph Title"
                                            value={localSeo.og_title || ''}
                                            onChange={(e) => handleChange('og_title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>OG Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            placeholder="Open Graph Description"
                                            value={localSeo.og_description || ''}
                                            onChange={(e) => handleChange('og_description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>OG Image URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="https://yoursite.com/og-image.jpg"
                                            value={localSeo.og_image || ''}
                                            onChange={(e) => handleChange('og_image', e.target.value)}
                                        />
                                        <Form.Control
                                            type="file"
                                            className='mt-2'
                                            placeholder="select image"
                                            onChange={(e) => handleImageChange(e, 'file_og_image')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Twitter Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Twitter Card Title"
                                            value={localSeo.twitter_title || ''}
                                            onChange={(e) => handleChange('twitter_title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Twitter Image URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="https://yoursite.com/twitter-image.jpg"
                                            value={localSeo.twitter_image || ''}
                                            onChange={(e) => handleChange('twitter_image', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Control
                                        type="file"
                                        className='mt-2'
                                        placeholder="select image"
                                        onChange={(e) => handleImageChange(e, 'file_twitter_image')}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Crical Title"
                                            value={localSeo.cronical_title || ''}
                                            onChange={(e) => handleChange('cronical_title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            placeholder="Crical Description"
                                            value={localSeo.cronical_description || ''}
                                            onChange={(e) => handleChange('cronical_description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Keywords</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Crical Keywords"
                                            value={localSeo.cronical_keywords || ''}
                                            onChange={(e) => handleChange('cronical_keywords', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Image</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="Crical Image"
                                            value={localSeo.cronical_image || ''}
                                            onChange={(e) => handleChange('cronical_image', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Control
                                        type="file"
                                        className='mt-2'
                                        placeholder="select image"
                                        onChange={(e) => handleImageChange(e, 'file_cronical_image')}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="Crical URL"
                                            value={localSeo.cronical_url || ''}
                                            onChange={(e) => handleChange('cronical_url', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>

                            </Row>
                            {/* Robots & Canonical */}
                            <div className="mt-4 mb-3" style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px' }}>
                                <h5 style={{ color: '#2c3e50', fontSize: '16px', fontWeight: 600 }}>Advanced Meta & Robots</h5>
                            </div>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Meta Robots</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="index, follow"
                                            value={localSeo.site_robots || 'index, follow'}
                                            onChange={(e) => handleChange('site_robots', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Canonical URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="https://yoursite.com/canonical-url"
                                            value={localSeo.cronical_url || ''}
                                            onChange={(e) => handleChange('cronical_url', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Analytics Section */}
                            <div className="mt-4 mb-3" style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px' }}>
                                <h5 style={{ color: '#2c3e50', fontSize: '16px', fontWeight: 600 }}>Analytics & Tracking</h5>
                            </div>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Google Analytics ID</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="UA-XXXXX-X or G-XXXXXXX"
                                            value={localSeo.google_analytics || ''}
                                            onChange={(e) => handleChange('google_analytics', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Facebook Pixel ID</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="XXXXXX"
                                            value={localSeo.facebook_pixel || ''}
                                            onChange={(e) => handleChange('facebook_pixel', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Google Tag Manager ID</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="GTM-XXXXXX"
                                            value={localSeo.google_tag_manager || ''}
                                            onChange={(e) => handleChange('google_tag_manager', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Structured Data Section */}
                            <div className="mt-4 mb-3" style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px' }}>
                                <h5 style={{ color: '#2c3e50', fontSize: '16px', fontWeight: 600 }}>Structured Data (Schema.org)</h5>
                            </div>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Schema Type</Form.Label>
                                        <Form.Select
                                            value={localSeo.schema_type || 'Organization'}
                                            onChange={(e) => handleChange('schema_type', e.target.value)}
                                        >
                                            <option value="Organization">Organization</option>
                                            <option value="Person">Medical Professional (Person)</option>
                                            <option value="MedicalBusiness">Medical Business</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Schema Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Business or Doctor Name"
                                            value={localSeo.schema_name || ''}
                                            onChange={(e) => handleChange('schema_name', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Custom Code Section */}
                            <div className="mt-4 mb-3" style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px' }}>
                                <h5 style={{ color: '#2c3e50', fontSize: '16px', fontWeight: 600 }}>Custom Headers & Scripts</h5>
                            </div>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Custom Meta Tags</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            placeholder='<meta name="custom" content="value">'
                                            value={localSeo.custom_meta_tags || ''}
                                            onChange={(e) => handleChange('custom_meta_tags', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Custom Head Code</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder="Add custom code to <head>"
                                            value={localSeo.custom_head_code || ''}
                                            onChange={(e) => handleChange('custom_head_code', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Custom Body Code</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder="Add custom code to <body>"
                                            value={localSeo.custom_body_code || ''}
                                            onChange={(e) => handleChange('custom_body_code', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div style={{ textAlign: 'right', marginTop: '30px', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        resetToDefault();
                                        setSelectedPage(null);
                                    }}
                                    style={{ marginRight: '12px' }}
                                >
                                    Reset to Default
                                </Button>
                                <Button
                                    variant="primary"
                                    onClick={() => handleSavePageSeo()}
                                    style={{ padding: '8px 24px', fontWeight: 600 }}
                                >
                                    {localSeo.id ? 'Update SEO Settings' : 'Save SEO Settings'}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeoSettings;
